import { Outlet, Routes } from "react-router";
import { Route, useParams } from "react-router-dom";
import AuthGuard from "~Common/AuthGuard/AuthGuard.tsx";
import ManageOrganizationsWrapper from "~Features/Organizations/ManageOrganizationsWrapper";
import { NotFoundPage } from "~pages/ErrorPages";
import { NavTabs } from "./components/NavTabs.tsx";
import useGetOrganizationTabRoutes from "./hooks/useGetOrganizationTabRoutes";

const OrganizationTabsRoutes = () => {
  const { customerId, sport, organizationId } = useParams();
  const routes = useGetOrganizationTabRoutes();

  const baseUrl = `/${customerId}/admin/${sport}/${organizationId}`;

  return (
    <Routes>
      <Route
        element={
          <ManageOrganizationsWrapper>
            <NavTabs routes={routes} baseUrl={baseUrl} />
            <Outlet />
          </ManageOrganizationsWrapper>
        }
      >
        {routes.map(({ Component, permissionKeys, key, path }) => (
          <Route
            key={key}
            path={path}
            element={
              <AuthGuard permissionKeys={permissionKeys}>
                <Component />
              </AuthGuard>
            }
          />
        ))}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default OrganizationTabsRoutes;
